module.exports = __webpack_public_path__ + "static/VetCode-08b3b60c79c11fee948f0eb74c473b20.jpg";